import type { StatusTone } from './Status'

// One map so the console and settings agree (Status card's lifecycle table,
// D192): in progress is info, an outcome success, a person or a change needed
// warning.
const lifecycleTones = new Map<string, StatusTone>([
  ['queued', 'neutral'],
  ['idle', 'neutral'],
  ['draft', 'neutral'],
  ['running', 'info'],
  ['compacting', 'info'],
  ['syncing', 'info'],
  ['reconciling', 'info'],
  ['active', 'info'],
  ['live', 'info'],
  ['blocked', 'warning'],
  ['needs approval', 'warning'],
  ['paused', 'warning'],
  ['needs you', 'warning'],
  ['changes requested', 'warning'],
  ['failed', 'danger'],
  ['cancelled by error', 'danger'],
  ['completed', 'success'],
  ['synced', 'success'],
  ['resolved', 'success'],
  // Run statuses (RunInfo.status), as the Runs board's dots show (D108).
  ['ok', 'success'],
  ['truncated', 'warning'],
  ['error', 'danger'],
  ['timeout', 'danger'],
  ['crashed', 'danger'],
  ['cancelled', 'neutral'],
])

export function lifecycleTone(state: string): StatusTone {
  return lifecycleTones.get(state) ?? 'neutral'
}
